module.exports = __webpack_public_path__ + "img/11.64388953.png";